import * as React from 'react';
import * as Classes from '../common/classes';
import classNames from 'classnames';
import { IAddonsProps, IProps } from '../common/props';

export interface IInputAddons extends IAddonsProps, IProps {
  children: React.ReactNode;
  limitedSize?: boolean;
}

export type InputAddonsProps = IInputAddons;

export const InputAddons = ({
  className,
  children,
  style,
  addonAfter,
  addonAfterCompact,
  limitedSize,
}: InputAddonsProps) => {
  if (addonAfter) {
    return (
      <div
        className={classNames(className, Classes.INPUT_ADDONS, {
          [Classes.INPUT_ADDONS_COMPACT]: addonAfterCompact,
          [Classes.INPUT_ADDONS_NO_COMPACT]: !addonAfterCompact,
          [Classes.INPUT_ADDONS_HAS_ADDON_AFTER]: !!addonAfter,
          [Classes.INPUT_ADDONS_LIMITED_SIZE]: limitedSize,
        })}
        style={style}
      >
        <div className={Classes.INPUT_ADDONS_INPUT}>{children}</div>
        <div className={Classes.INPUT_ADDONS_ADDON_AFTER}>{addonAfter}</div>
      </div>
    );
  } else {
    return <>{children}</>;
  }
};
